import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash/cloneDeep'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import { getSubscriptions } from '../../../EmailSubscriptionCenter/Data/SubscriptionCenterDataSource.js'
import { getUrlParameter, isPdfUrl } from '../../../../global/data/url.js'
import {
  getItemsInCart,
  addToCart,
  removeFromCart,
} from '../../../../global/cart.js'
import {
  ETF_INDEX_FUND,
  FUTURE_SCHOLAR_529,
  MODEL_PORTFOLIOS,
} from '../../Helpers/FundTypes.js'
import {
  isInvestor,
  isLoggedIntoSubscriptionCenter,
} from '../../../../global/authentication/authentication-manager.js'
import { updateFundSubscriptionBySubscriptionId } from '../../../EmailSubscriptionCenter/Modal/Data/subscriptions.js'
import { updateCartCount } from '../../../../global/_nav.js'
import { MODAL_TYPE_FUND } from '../../../EmailSubscriptionCenter/Landing/Helper/constants.js'
import { getAllSubscriptionsFromSubscriptionProfile } from '../../../EmailSubscriptionCenter/Landing/Helper/helper.js'

function FundLiterature(props) {
  const {
    fund,
    subscriptionProfile,
    setShowEmailSubscriptionCenterModal,
    fundSubscription,
    setFundSubscription,
  } = props
  const { literature } = fund
  const [cart, setCart] = useState(getItemsInCart())
  const [subscriptions, setSubscriptions] = useState([])
  const PRODUCT_LITERATURE = 'Product Literature'

  useEffect(() => {
    const loadSubscriptionData = async () => {
      const result = await getSubscriptions()
      setSubscriptions(result?.subscriptions)
    }
    loadSubscriptionData()
  }, [])

  useEffect(() => {
    initializeThermostat()
  }, [fundSubscription])

  const initializeThermostat = () => {
    const _fundSubscription = cloneDeep(fundSubscription)
    const findSub = subscriptions?.find(
      (i) => i.name === 'Columbia Thermostat Fund Allocation Update'
    )
    const findIndex = _fundSubscription?.activeLiterature?.findIndex(
      (i) => i.name === 'Thermostat Fund Asset Allocation Update'
    )
    if (
      findIndex >= 0 &&
      findSub &&
      _fundSubscription?.activeLiterature[findIndex]?.id !== findSub?.id
    ) {
      const subscriptionData = getAllSubscriptionsFromSubscriptionProfile(
        subscriptionProfile?.value
      )?.find(
        (i) =>
          i?.publication?.publicationType === findSub?.category &&
          i?.publication?.publicationID === findSub?.id
      )
      const { id, frequency, availableRoles, wholesalerLabel } = findSub
      const activeLiterature = _fundSubscription?.activeLiterature?.map(
        (item, index) =>
          index === findIndex
            ? {
                ...item,
                wholesalerLabel,
                active: findSub?.status === 'Active',
                id,
                frequency,
                availableRoles,
                preSelected: subscriptionData?.status === 'Active',
                selected: subscriptionData?.status === 'Active',
              }
            : item
      )

      setFundSubscription({
        ..._fundSubscription,
        activeLiterature,
      })
    }
  }
  const hasAddToCartLiterature = (literatureDocs) => {
    if (literatureDocs) {
      return literatureDocs.find(
        (literatureDoc) => literatureDoc.mailOrder === 'true'
      )
    }
    return false
  }

  const hasFundSubscriptions = fundSubscription && true
  const hasCartOrderableItems =
    hasAddToCartLiterature(literature.productDocuments.value) ||
    hasAddToCartLiterature(literature.regulatoryDocuments.value)

  const handleSubscribeClicked = async (event) => {
    event.persist()

    const _fundSubscription = cloneDeep(fundSubscription)
    const doc = _fundSubscription.activeLiterature.find(
      (doc) => doc.id === event.target.value
    )

    if (isLoggedIntoSubscriptionCenter()) {
      doc.selected = event.target.checked

      updateFundSubscriptionBySubscriptionId(
        subscriptionProfile,
        doc.id,
        doc.selected
      )
      setFundSubscription(_fundSubscription)
    } else {
      doc.selected = true
      setShowEmailSubscriptionCenterModal(true, MODAL_TYPE_FUND)
      setFundSubscription(_fundSubscription)
    }

    return null
  }

  const handleManageAllSubscriptionsClicked = (event) => {
    event.preventDefault()

    window.open('/subscribe', '_blank')
    window.focus()
  }

  function handleAddToCartClick(event) {
    if (event.target.checked) {
      addToLocalCart(JSON.parse(event.target.value))
    } else {
      removeFromLocalCart(JSON.parse(event.target.value))
    }

    updateCartCount()
  }

  function addToLocalCart(item) {
    addToCart(item)
    const _cart = [...cart]
    _cart.push(item)
    setCart(_cart)
  }

  function removeFromLocalCart(item) {
    removeFromCart(item)
    let _cart = [...cart]
    _cart = _cart.filter((cartItem) => item.cartId !== cartItem.cartId)
    setCart(_cart)
  }

  const getAddToCartButton = (form) => {
    const cusip = getUrlParameter('cusip')
    const cartId = cusip + form.docTitle.replace(/ /g, '_')

    const fundDocForSerialization = {}

    fundDocForSerialization.cartId = cartId
    fundDocForSerialization.fundName = fund.fundName

    fundDocForSerialization.productType = fund.fundGroup

    fundDocForSerialization.dDocType = form.docTitle
    fundDocForSerialization.fileName = form.docTitle
    fundDocForSerialization.fileDDocType = form.docTitle

    fundDocForSerialization.fileUrl = form.docURL
    fundDocForSerialization.quantity = 1
    // eslint-disable-next-line eqeqeq
    fundDocForSerialization.orderable = form.emailOrder == 'true'

    fundDocForSerialization.fundClass = fund.fundClass

    const cartJson = JSON.stringify(fundDocForSerialization)

    const isInCart =
      false || (cart.find((cartItem) => cartItem.cartId === cartId) && true)

    return (
      <>
        <input
          defaultChecked={isInCart}
          id={'cartDoc' + cartId}
          onChange={handleAddToCartClick}
          value={cartJson}
          type="checkbox"
          className="Subscription-checkbox"
          data-analytics="add-to-cart-checkbox"
        ></input>
        <label htmlFor={'cartDoc' + cartId}>
          <p className="u-inlineBlock u-marginLeft1gu">
            {isInCart ? 'In Cart' : 'Add to Cart'}{' '}
          </p>
        </label>
      </>
    )
  }

  addSortOrder(literature)
  sortDocuments(literature)

  return (
    <div>
      <div
        className="u-paddingVert12gu"
        data-analytics-component-name="Fund Literature"
      >
        <div className="Grid Grid--alignMiddle u-marginBottom4gu u-sm-marginBottom1gu">
          <div className="u-paddingRight2gu u-sizeFill">
            <h2 className="u-marginBottom3gu">Literature</h2>
          </div>
          <div className="u-sizeFit">
            {hasFundSubscriptions && (
              <a
                className="js-manage-all-subs-link Link u-textSecondary u-textSolid u-textDivider"
                data-analytics="cesc-subscribe-link"
                data-qa-automation="subscribe-button"
                href="#"
                onClick={handleManageAllSubscriptionsClicked}
              >
                Manage all subscriptions
              </a>
            )}{' '}
            {hasCartOrderableItems && (
              <a
                className="js-subnav-link Link u-textSecondary u-textSolid"
                href={
                  getRelativeBasePath() + '/resources/literature/cart-order/'
                }
              >
                View cart
              </a>
            )}
          </div>
        </div>
        <div className="Grid Grid--withGutter">
          {displayProductLitearature(literature.productDocuments) && (
            <div
              className={`${
                fund.fundGroup === ETF_INDEX_FUND ||
                fund.fundGroup === MODEL_PORTFOLIOS
                  ? 'u-size12of12'
                  : 'u-size6of12'
              } u-sm-sizeFull`}
            >
              {renderTable(
                fund,
                PRODUCT_LITERATURE,
                literature.productDocuments.value,
                hasFundSubscriptions,
                hasAddToCartLiterature(literature.productDocuments.value)
              )}
            </div>
          )}

          {fund.fundGroup !== ETF_INDEX_FUND &&
            fund.fundGroup !== MODEL_PORTFOLIOS && (
              <div className="u-size6of12 u-sm-sizeFull">
                {renderTable(
                  fund,
                  getResourceColumnTitle(fund),
                  literature.regulatoryDocuments.value,
                  false,
                  hasAddToCartLiterature(literature.regulatoryDocuments.value)
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  )

  function displayProductLitearature(productDocuments) {
    let unsecureCount = -1

    productDocuments.value.some(function (document, index) {
      if (document.secure === 'false') {
        unsecureCount = index
      }
    })

    return productDocuments.value.length > 0 && unsecureCount >= 0
  }

  function getResourceColumnTitle(fund) {
    return fund.fundGroup === FUTURE_SCHOLAR_529
      ? 'Resources'
      : 'Regulatory Resources'
  }

  function renderTable(
    fund,
    title,
    documents,
    renderEmailUpdates,
    renderMailOrder
  ) {
    return (
      <table className="Table">
        <thead className="Table-head">
          <tr className="Table-row u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
            <th className="Table-header u-bgColorTransparent u-paddingLeft0">
              <h3>{title}</h3>
            </th>
            {renderEmailUpdates && (
              <th className="Table-header u-bgColorTransparent u-paddingRight0">
                <p className="u-textColorLight u-textNormal u-textSecondary">
                  Email Updates
                </p>
              </th>
            )}
            {renderMailOrder && (
              <th className="Table-header u-bgColorTransparent u-paddingRight0">
                {fund.fundGroup !== ETF_INDEX_FUND && (
                  <p className="u-textColorLight u-textNormal u-textSecondary">
                    Mail Order
                  </p>
                )}
              </th>
            )}
          </tr>
        </thead>
        <tbody className="Table-body">
          {documents.map((document, index) => {
            const renderDocument =
              (document.secure === 'true' && !isInvestor()) ||
              document.secure === 'false'

            const hasSalesforceSub = (doc) => {
              let docName = doc?.name

              if (doc?.name === 'Commentary') {
                docName = 'Quarterly Fund Commentary'
              }

              return docName === document.docTitle
            }

            if (renderDocument) {
              return (
                <tr
                  className="Table-row u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0"
                  key={`lit${index}`}
                >
                  <td className="Table-cell u-paddingLeft0">
                    {document.isDataFile === 'true' ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: renderDocUrlHtml(document),
                        }}
                      />
                    ) : (
                      renderDocUrlHtml(document)
                    )}
                  </td>
                  {renderEmailUpdates &&
                    (fundSubscription?.activeLiterature?.some(
                      hasSalesforceSub
                    ) ? (
                      <td className="Table-cell">
                        {renderSubscribeButton(document)}
                      </td>
                    ) : (
                      <td></td>
                    ))}
                  {renderMailOrder && (
                    <td className="Table-cell u-paddingRight0 u-textNoWrap u-paddingLeft2gu">
                      {document.mailOrder === 'true' &&
                        document.secure === 'false' &&
                        fund.fundGroup !== ETF_INDEX_FUND &&
                        getAddToCartButton(document)}
                    </td>
                  )}
                </tr>
              )
            }
          })}
        </tbody>
      </table>
    )
  }

  // HACK - service needs to return DOCTYPE to properly sort
  function addSortOrder(literature) {
    const docs = [
      'Fact Sheet',
      'QDIA Fact Sheet',
      'Monthly Update',
      'Monthly Fund Commentary',
      'Quarterly Fund Commentary',
      'Investor Guide',
      'Investment Insights',
      'Attribution/Contribution',
      'Mutual Fund Guide',
    ]
    const docTitleDiff = {
      // 'Monthly Fund Commentary': 'Fund Commentary',
      // 'Quarterly Fund Commentary': 'Fund Commentary'
    }

    const base = literature.productDocuments.value

    base.forEach((obj, i) => {
      let title = obj.docTitle
      let index = docs.indexOf(title)

      if (index < 0) {
        // If Document title doesn't exist in doc array
        const keys = Object.keys(docTitleDiff)
        const index2 = keys.indexOf(title)

        if (index2 < 0) {
          // For Investment Insights doc with Unique titles
          title = 'Investment Insights'
          index = docs.indexOf(title)
        }
        // else {
        //   // Adaptive Risk Allocation: Monthly Fund Commentary == Fund Commentary
        //   title = docTitleDiff['Monthly Fund Commentary']
        //   index = docs.indexOf(title)
        // }
      }

      base[i].docType = title
      base[i].sortOrder = index + 1
    })
  }

  function sortDocuments(literature) {
    const base = literature.productDocuments.value

    base.sort(function (a, b) {
      return a.sortOrder - b.sortOrder
    })
  }

  function renderSubscribeButton(doc) {
    let foundSubscription = null
    switch (doc.docTitle) {
      case 'Fact Sheet':
        foundSubscription = findSubscriptionLiterature('Fact Sheet')
        break
      case 'Attribution/Contribution':
        foundSubscription = findSubscriptionLiterature(
          'Attribution/Contribution Report'
        )
        break
      case 'Monthly Fund Commentary':
        foundSubscription = findSubscriptionLiterature(
          'Monthly Fund Commentary'
        )
        break
      case 'Fund Commentary':
      case 'Quarterly Fund Commentary':
        foundSubscription = findSubscriptionLiterature('Commentary')
        break
      case 'Thermostat Fund Asset Allocation Update':
        foundSubscription = findSubscriptionLiterature(
          'Thermostat Fund Asset Allocation Update'
        )
        break
      default:
    }
    return foundSubscription && getSubscribeHtml(foundSubscription)
  }

  function getSubscribeHtml(foundSubscription) {
    if (isLoggedIntoSubscriptionCenter()) {
      return (
        <>
          <input
            checked={foundSubscription.selected}
            id={'doc' + foundSubscription.id}
            onChange={handleSubscribeClicked}
            value={foundSubscription.id}
            type="checkbox"
            className="Subscription-checkbox"
            data-analytics="cesc-subscribe-checkbox"
          ></input>
          <label htmlFor={'doc' + foundSubscription.id}>
            <p className="u-inlineBlock u-marginLeft1gu">
              {foundSubscription.selected ? 'Subscribed' : 'Subscribe'}{' '}
            </p>
          </label>
        </>
      )
    } else {
      return (
        <button
          value={foundSubscription.id}
          className="Button Button--tertiary u-posRelative u-padding0 Add-to-cart u-textNoTransform"
          data-analytics="cesc-subscribe-link"
          data-qa-automation="subscribe-button"
          onClick={handleSubscribeClicked}
        >
          Subscribe
        </button>
      )
    }
  }

  function findSubscriptionLiterature(name) {
    return (
      fundSubscription &&
      fundSubscription.activeLiterature &&
      fundSubscription.activeLiterature.find(
        (doc) => doc.active && doc.name === name
      )
    )
  }

  function renderDocUrlHtml(document) {
    let docURLAsHtml

    if (document.isDataFile === 'true') {
      const basePath = 'href="' + getRelativeBasePath() + '/'
      const strippedHtml = document.docURL
        .replace('<p>', '')
        .replace('</p>', '')

      docURLAsHtml =
        strippedHtml.indexOf('/content/') > 0
          ? strippedHtml
          : strippedHtml.replace('href="/', basePath)
    }

    const secureLinkClass =
      document.secure === 'true' ? 'locked-document-link' : ''
    const lockedDocumentHtml = (
      <a
        href={document.docURL}
        data-analytics={document.docTitle}
        target={isPdfUrl(document.docURL) ? '_blank' : '_self'}
        rel="noopener noreferrer"
        className={secureLinkClass}
        dangerouslySetInnerHTML={{
          __html: getDocTitleWithExtension(document.docTitle, document.docURL),
        }}
      ></a>
    )

    return docURLAsHtml || lockedDocumentHtml
  }

  function getDocTitleWithExtension(docTitle, docURL) {
    const extension = isPdfUrl(docURL) ? ' (PDF)' : ''
    return docTitle + extension
  }
}

FundLiterature.propTypes = {
  fund: PropTypes.object.isRequired,
  subscriptionProfile: PropTypes.object,
  showEmailSubscriptionModal: PropTypes.bool,
  setShowEmailSubscriptionCenterModal: PropTypes.func,
  fundSubscription: PropTypes.object,
  setFundSubscription: PropTypes.func,
}

export default FundLiterature
